module.exports = __webpack_public_path__ + "static/img/mini05.ad1984d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/soft/mini05.jpg
// module id = y1O/
// module chunks = 0